import { get } from "lodash";
import { handleError } from "../helpers/generel.helpers";
import { showToaster } from "../helpers/toaster.helpers";
import { playlistServices } from "../services/playlist.service";
import { generalHelpers } from "../helpers";

export const fetchPlaylistById = async (id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const res = await playlistServices.fetchPlaylistById(id);
    const playlist = get(res, "data.data", []);
    const songs = generalHelpers.getFormattedSongs(playlist.songs);
    return {
      ...playlist,
      songs,
    };
  } catch (error) {
    handleError(error);
    return {};
  }
};

export const updatePlaylist = async (id, payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    await playlistServices.updatePlaylist(id, payload);

    showToaster("success", "Playlist updated successfully");
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

export const deletePlaylist = async (id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    await playlistServices.deletePlaylist(id);
    showToaster("success", "Playlist deleted successfully");
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

export const addPlaylist = async (payload, userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline please connect to the internet to add playlist"
    );
  }
  try {
    const res = await playlistServices.addPlaylist(payload);
    showToaster("success", "Playlist added successfully");

    return get(res, "data.data", {});
  } catch (error) {
    handleError(error);
    return "";
  }
};

export const addImage = async (playlistId, payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    await playlistServices.addImage(playlistId, payload);
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

export const downloadPlaylist = async (playlistId, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const res = await playlistServices.downloadPlaylist(playlistId);
    return get(res, "data", "");
  } catch (error) {
    handleError(error);
    return "";
  }
};
